import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BottomNav from './components/BottomNav';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import LoginPage from './pages/LoginPage';
import AccountPage from './pages/AccountPage';
import AdminPage from './pages/AdminPage';
import PoliciesPage from './pages/PoliciesPage';
import ContactPage from './pages/ContactPage';
import { startKeepAlive } from './utils/keepAlive';
import './index.css';

const Layout = ({ children, noFooter }) => (
  <>
    <Navbar />
    <main>{children}</main>
    {!noFooter && <Footer />}
    <BottomNav />
  </>
);

function App() {
  useEffect(() => {
    startKeepAlive();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <CartProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              style: { background: '#0a0a0a', color: '#fff', fontSize: '13px' },
              success: { iconTheme: { primary: '#c9a96e', secondary: '#fff' } },
            }}
          />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={
              <AdminRoute><AdminPage /></AdminRoute>
            } />
            <Route path="/" element={<Layout><HomePage /></Layout>} />
            <Route path="/shop" element={<Layout><ShopPage /></Layout>} />
            <Route path="/product/:id" element={<Layout><ProductDetailPage /></Layout>} />
            <Route path="/cart" element={<Layout><CartPage /></Layout>} />
            <Route path="/checkout" element={
              <Layout><ProtectedRoute><CheckoutPage /></ProtectedRoute></Layout>
            } />
            <Route path="/order-confirmation/:id" element={
              <Layout><ProtectedRoute><OrderConfirmationPage /></ProtectedRoute></Layout>
            } />
            <Route path="/track" element={<Layout><OrderTrackingPage /></Layout>} />
            <Route path="/track/:orderId" element={<Layout><OrderTrackingPage /></Layout>} />
            <Route path="/account" element={
              <Layout><ProtectedRoute><AccountPage /></ProtectedRoute></Layout>
            } />
            <Route path="/orders" element={
              <Layout><ProtectedRoute><AccountPage /></ProtectedRoute></Layout>
            } />
            <Route path="/policies/:type" element={<Layout><PoliciesPage /></Layout>} />
            <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
            <Route path="*" element={
              <Layout>
                <div className="empty-state" style={{paddingTop:'120px'}}>
                  <h3>Page Not Found</h3>
                  <p>The page you're looking for doesn't exist.</p>
                  <a href="/" className="btn btn-primary" style={{marginTop:'24px'}}>Go Home</a>
                </div>
              </Layout>
            } />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
